import React from 'react';
import {
	Card, Input, Button, Table, Modal, Form, Select, Switch, Spin, Divider,
	message, Tag, Tooltip, Typography, Pagination,
} from 'antd';
import {
	SearchOutlined, PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, RedoOutlined, UndoOutlined, SaveOutlined,
	CloseCircleOutlined, EditOutlined, PlusCircleOutlined, DesktopOutlined,
	TagOutlined, SafetyCertificateOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Perangkat / MAC Address',
	apiUrl: { data: 'master/api/mac-address/' },
};

const config = new Config();

// 3 nilai yang dikenali updater.py (app_cetak) - layanan_char dipakai utk
// nentuin exe mana (kutipan.exe/notice.exe) yang jatah device ini. Dibatasi
// Select (bukan free-text) biar gak ada typo yang bikin device salah app.
const LAYANAN_OPTIONS = [
	{ value: 'kutipan', label: 'Kutipan' },
	{ value: 'notice', label: 'Notice' },
	{ value: 'samkel', label: 'Samkel' },
];

function layananLabel(value) {
	const found = LAYANAN_OPTIONS.find(o => o.value === value);
	return found ? found.label : (value || '—');
}

// Fase 7 (version-gating bertahap) - override per-device, DUA ARAH:
// kosong = ikut enforcement_mode GLOBAL (menu Pengaturan Secrets >
// Konfigurasi App Cetak). Diisi = menang dari global (bisa dipakai utk uji
// coba terbatas MAUPUN pengecualian saat rollout wajib).
const ENFORCEMENT_OVERRIDE_OPTIONS = [
	{ value: '', label: 'Ikut Global' },
	{ value: 'off', label: 'Off' },
	{ value: 'warn', label: 'Warn' },
	{ value: 'block', label: 'Block' },
];

function enforcementOverrideLabel(value) {
	const found = ENFORCEMENT_OVERRIDE_OPTIONS.find(o => o.value === (value || ''));
	return found ? found.label : value;
}

class DataMacAddress extends React.Component {
	formModalRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,

			modalVisible: false,
			modalMode: 'tambah',
			modalEditId: null,
			modalLoadingData: false,
			modalLoadingSubmit: false,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&include_deleted=true')
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({ dataSource: data.results, pagination: { ...prev.pagination, total: data.count } }));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => { message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' }); this.setState({ loadingData: false }); });
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	// ── Toggle status whitelist (terpisah dari soft-delete) ──────────
	handleToggleStatus(row) {
		this.props.ajaxHandler('patch', configClass.apiUrl.data + row.id + '/', { status: !row.status }, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: row.status ? 'Perangkat dinonaktifkan dari whitelist' : 'Perangkat diaktifkan di whitelist', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.error({ content: 'Gagal mengubah status', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }));
	}

	// ── Nonaktifkan (soft-delete) & Aktifkan kembali (restore) ────────
	showDeleteConfirm(id, mac) {
		Modal.confirm({
			title: 'Nonaktifkan Perangkat',
			icon: <ExclamationCircleOutlined />,
			content: `Perangkat "${mac}" akan dinonaktifkan dan tidak bisa lagi lolos cek whitelist. Data tetap tersimpan dan bisa diaktifkan kembali.`,
			okText: 'Nonaktifkan', okType: 'danger', cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menonaktifkan...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Perangkat berhasil dinonaktifkan', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.error({ content: 'Gagal menonaktifkan data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menonaktifkan data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' }));
	}

	showRestoreConfirm(id, mac) {
		Modal.confirm({
			title: 'Aktifkan Perangkat',
			icon: <UndoOutlined style={{ color: '#52c41a' }} />,
			content: `Perangkat "${mac}" akan dipulihkan dan masuk daftar lagi (status whitelist ikut nilai sebelumnya, periksa kembali setelah dipulihkan).`,
			okText: 'Aktifkan', okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
			cancelText: 'Batal',
			onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Perangkat berhasil dipulihkan', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.error({ content: 'Gagal memulihkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' }));
	}

	// ── Modal tambah/edit ─────────────────────────────────────────────
	openAddModal = () => {
		this.setState({ modalVisible: true, modalMode: 'tambah', modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	openEditModal = (row) => {
		this.setState({ modalVisible: true, modalMode: 'edit', modalEditId: row.id });
		if (this.formModalRef.current) {
			this.formModalRef.current.resetFields();
			this.formModalRef.current.setFieldsValue({
				mac_address: row.mac_address,
				keterangan: row.keterangan,
				layanan_char: row.layanan_char,
				status: row.status,
				samkel: row.samkel,
				netbird_api_key: row.netbird_api_key,
				enforcement_mode_override: row.enforcement_mode_override || '',
			});
		}
	}

	closeModal = () => {
		if (this.state.modalLoadingSubmit) return;
		this.setState({ modalVisible: false, modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	handleModalSubmit = (values) => {
		const { modalMode, modalEditId } = this.state;
		const method = modalMode === 'edit' ? 'put' : 'post';
		const url = modalMode === 'edit' ? configClass.apiUrl.data + modalEditId + '/' : configClass.apiUrl.data;
		this.setState({ modalLoadingSubmit: true });
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler(method, url, values, false, true)
			.then(() => {
				this.setState({ modalLoadingSubmit: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.closeModal();
					this.getData();
				} else {
					message.destroy();
					this.setState({ errTitle: 'Gagal menyimpan data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => { this.setState({ modalLoadingSubmit: false }); message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }); });
	}

	// ── Render modal ──────────────────────────────────────────────────
	renderModal() {
		const { modalVisible, modalMode, modalLoadingSubmit, isMobile } = this.state;
		const isEdit = modalMode === 'edit';

		const header = (
			<div style={{ background: 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)', borderRadius: isMobile ? 0 : '8px 8px 0 0', padding: isMobile ? '14px 18px' : '20px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14 }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{ width: isMobile ? 36 : 44, height: isMobile ? 36 : 44, flexShrink: 0, borderRadius: 10, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						{isEdit ? <EditOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} /> : <PlusCircleOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>{isEdit ? 'Edit Perangkat' : 'Tambah Perangkat'}</div>
						{!isMobile && <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>{isEdit ? 'Ubah informasi MAC address' : 'Daftarkan MAC address device baru'}</div>}
					</div>
				</div>
				<Button type="text" icon={<CloseCircleOutlined style={{ fontSize: 18 }} />} onClick={this.closeModal} disabled={modalLoadingSubmit} style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }} />
			</div>
		);

		const formBody = (
			<div style={{ padding: isMobile ? '18px 16px 0' : '24px 28px 0' }}>
				<Form
					ref={this.formModalRef}
					layout="vertical"
					onFinish={this.handleModalSubmit}
					initialValues={{ status: true, samkel: false, enforcement_mode_override: '' }}
				>
					<Form.Item
						label={<span><DesktopOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />MAC Address</span>}
						name="mac_address"
						rules={[{ required: true, message: 'MAC address harus diisi' }]}
						extra="Format bebas (AA:BB:CC:DD:EE:FF atau AA-BB-CC-DD-EE-FF)."
					>
						<Input placeholder="AA:BB:CC:DD:EE:FF" style={{ borderRadius: 8, height: 38, fontFamily: 'monospace' }} />
					</Form.Item>

					<Form.Item
						label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Keterangan</span>}
						name="keterangan"
						rules={[{ required: true, message: 'Keterangan harus diisi' }]}
					>
						<Input placeholder="Contoh: Printer Kutipan UPT Palangka Raya" style={{ borderRadius: 8, height: 38 }} />
					</Form.Item>

					<Form.Item
						label="Layanan"
						name="layanan_char"
						rules={[{ required: true, message: 'Layanan harus dipilih' }]}
					>
						<Select placeholder="Pilih layanan..." options={LAYANAN_OPTIONS} style={{ borderRadius: 8 }} />
					</Form.Item>

					<Form.Item
						label={<span><SafetyCertificateOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />NetBird API Key (opsional)</span>}
						name="netbird_api_key"
						extra="Kredensial VPN per-device - biarkan kosong kalau device ini tidak memakai NetBird."
					>
						<Input.Password placeholder="Kosongkan jika tidak dipakai" style={{ borderRadius: 8, height: 38 }} autoComplete="new-password" />
					</Form.Item>

					<Form.Item
						label="Override Enforcement (Version-Gating)"
						name="enforcement_mode_override"
						extra='Kosongkan ("Ikut Global") kecuali device ini perlu pengecualian khusus dari aturan global di menu Pengaturan Secrets > Konfigurasi App Cetak.'
					>
						<Select options={ENFORCEMENT_OVERRIDE_OPTIONS} style={{ borderRadius: 8 }} />
					</Form.Item>

					<div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
						<Form.Item label="Aktif di Whitelist" name="status" valuePropName="checked" style={{ marginBottom: 0 }}>
							<Switch checkedChildren="Aktif" unCheckedChildren="Nonaktif" />
						</Form.Item>
						<Form.Item label="Perangkat Samkel" name="samkel" valuePropName="checked" style={{ marginBottom: 0 }}>
							<Switch checkedChildren="Ya" unCheckedChildren="Tidak" />
						</Form.Item>
					</div>
				</Form>
			</div>
		);

		const footer = (
			<div>
				<Divider style={{ margin: '16px 0 0' }} />
				<div style={{ padding: isMobile ? '14px 16px' : '16px 28px', display: 'flex', flexDirection: isMobile ? 'column-reverse' : 'row', justifyContent: isMobile ? 'stretch' : 'flex-end', gap: 10, background: '#fafafa', borderRadius: isMobile ? 0 : '0 0 8px 8px' }}>
					<Button icon={<CloseCircleOutlined />} onClick={this.closeModal} disabled={modalLoadingSubmit} style={{ borderRadius: 8, height: 40, width: isMobile ? '100%' : 'auto' }}>Batal</Button>
					<Button type="primary" icon={<SaveOutlined />} loading={modalLoadingSubmit} onClick={() => this.formModalRef.current && this.formModalRef.current.submit()} style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, height: 40, width: isMobile ? '100%' : 'auto' }}>
						{isEdit ? 'Simpan Perubahan' : 'Tambah Perangkat'}
					</Button>
				</div>
			</div>
		);

		return (
			<Modal visible={modalVisible} onCancel={this.closeModal} footer={null} title={null} closable={false} width={isMobile ? 'calc(100vw - 16px)' : 540} style={isMobile ? { top: 12, margin: '0 8px' } : { top: 40 }} bodyStyle={{ padding: 0 }} maskClosable={!modalLoadingSubmit} destroyOnClose>
				{header}{formBody}{footer}
			</Modal>
		);
	}

	// ── Table columns ─────────────────────────────────────────────────
	_buildColumns() {
		return [
			{ title: 'No', key: 'no', width: 56, align: 'center', render: (_, __, index) => { const { pagination } = this.state; return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>; } },
			{
				title: 'MAC Address', dataIndex: 'mac_address', key: 'mac_address',
				render: (value, row) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{ width: 34, height: 34, borderRadius: 8, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<DesktopOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div>
							<div style={{ fontWeight: 700, fontSize: 13, color: '#222', fontFamily: 'monospace' }}>{value}</div>
							<div style={{ fontSize: 12, color: '#888', marginTop: 1 }}>{row.keterangan || '—'}</div>
						</div>
					</div>
				),
			},
			{
				title: 'Layanan', dataIndex: 'layanan_char', key: 'layanan_char', width: 110, align: 'center',
				render: (val) => <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }}>{layananLabel(val)}</Tag>,
			},
			{
				title: 'Samkel', dataIndex: 'samkel', key: 'samkel', width: 90, align: 'center',
				render: (val) => val ? <Tag color="purple" style={{ borderRadius: 20, fontSize: 11 }}>Samkel</Tag> : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>,
			},
			{
				title: 'Override', dataIndex: 'enforcement_mode_override', key: 'enforcement_mode_override', width: 110, align: 'center',
				render: (val) => val
					? <Tag color={val === 'block' ? 'red' : val === 'warn' ? 'orange' : 'default'} style={{ borderRadius: 20, fontSize: 11 }}>{enforcementOverrideLabel(val)}</Tag>
					: <Text type="secondary" style={{ fontSize: 12 }}>Ikut Global</Text>,
			},
			{
				title: 'Whitelist', dataIndex: 'status', key: 'status', width: 110, align: 'center',
				render: (val, row) => row.deleted_at ? (
					<Text type="secondary" style={{ fontSize: 12 }}>—</Text>
				) : (
					<Switch size="small" checked={val} onChange={() => this.handleToggleStatus(row)} checkedChildren="Aktif" unCheckedChildren="Nonaktif" />
				),
			},
			{
				title: 'Status', dataIndex: 'deleted_at', key: 'deleted_at_status', width: 110, align: 'center',
				render: (val) => val
					? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Tidak Aktif</Tag>
					: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>,
			},
			{
				title: 'Aksi', key: 'aksi', width: 100, fixed: 'right', align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							<Button size="small" shape="circle" type="primary" ghost disabled={!!row.deleted_at} onClick={() => !row.deleted_at && this.openEditModal(row)}><FormOutlined /></Button>
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan"><Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id, row.mac_address)}><CloseSquareOutlined /></Button></Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali"><Button size="small" shape="circle" style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showRestoreConfirm(row.id, row.mac_address)}><UndoOutlined /></Button></Tooltip>
						)}
					</div>
				),
			},
		];
	}

	// ── Mobile card ───────────────────────────────────────────────────
	renderMobileCard(row) {
		return (
			<Card key={row.id} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
					<div style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<DesktopOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', lineHeight: 1.3, fontFamily: 'monospace' }}>{row.mac_address}</div>
						<div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{row.keterangan || '—'}</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
							<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>{layananLabel(row.layanan_char)}</Tag>
							{row.samkel && <Tag color="purple" style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>Samkel</Tag>}
							{row.enforcement_mode_override && (
								<Tag color={row.enforcement_mode_override === 'block' ? 'red' : row.enforcement_mode_override === 'warn' ? 'orange' : 'default'} style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>
									Override: {enforcementOverrideLabel(row.enforcement_mode_override)}
								</Tag>
							)}
							{row.deleted_at
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Tidak Aktif</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Aktif</Tag>
							}
						</div>
					</div>
				</div>
				<div style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					{row.deleted_at ? (
						<Text type="secondary" style={{ fontSize: 12 }}>Whitelist —</Text>
					) : (
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<Text style={{ fontSize: 12, color: '#6b7280' }}>Whitelist</Text>
							<Switch size="small" checked={row.status} onChange={() => this.handleToggleStatus(row)} checkedChildren="Aktif" unCheckedChildren="Nonaktif" />
						</div>
					)}
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							<Button size="middle" shape="circle" type="primary" ghost disabled={!!row.deleted_at} onClick={() => !row.deleted_at && this.openEditModal(row)}><FormOutlined /></Button>
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan"><Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id, row.mac_address)}><CloseSquareOutlined /></Button></Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali"><Button size="middle" shape="circle" style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showRestoreConfirm(row.id, row.mac_address)}><UndoOutlined /></Button></Tooltip>
						)}
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;
		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-mac-wrap .ant-table-thead > tr > th { background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important; font-weight: 700; font-size: 13px; color: #0f2847; border-bottom: 2px solid #d0dff5; }
						.data-mac-wrap .ant-table-tbody > tr > td { padding: 12px 16px; vertical-align: middle; }
						.data-mac-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-mac-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-mac-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.data-mac-wrap .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
						.data-mac-wrap .row-nonaktif:hover > td { opacity: 0.75 !important; background: #fff1f0 !important; }
						.data-mac-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 13px; }
					`}</style>
				</Helmet>
				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />
				{this.renderModal()}
				<Card className="data-mac-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{ padding: isMobile ? '14px 16px' : '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 17 }}><DesktopOutlined style={{ marginRight: 8 }} />{configClass.title}</div>
							{!isMobile && <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>Total {pagination.total || 0} perangkat terdaftar{loadingData && ' · Memuat...'}</div>}
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data"><Button onClick={() => this.setState(prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }), () => this.getData(this.state.pagination.pageSize, 0, ''))} icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>{!isMobile && 'Refresh'}</Button></Tooltip>
							<Button type="primary" icon={<PlusOutlined />} onClick={this.openAddModal} style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}>{isMobile ? 'Tambah' : 'Tambah Perangkat'}</Button>
						</div>
					</div>
					<div style={{ padding: isMobile ? '10px 12px' : '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}</Text>
						<Input
							placeholder="Cari MAC address atau keterangan..."
							allowClear
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: isMobile ? '100%' : 340, width: isMobile ? '100%' : 'auto' }}
							value={searchText}
							onChange={this.handleSearchChange}
						/>
					</div>
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div> : dataSource.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Belum ada perangkat terdaftar</div> : dataSource.map(row => this.renderMobileCard(row))}
								{pagination.total > 0 && <div style={{ textAlign: 'center', padding: '12px 0 4px' }}><Pagination current={pagination.current} pageSize={pagination.pageSize} total={pagination.total} onChange={this.handleMobilePageChange} showSizeChanger={false} simple /></div>}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''}
								pagination={{
									current: pagination.current, pageSize: pagination.pageSize, total: pagination.total,
									showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataMacAddress);
